import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/assigned_advisor_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedAssignedAdvisorFilterView extends Common.Dashboard.Filters.ToggleableUnappliedFilterView

  initialize: ({filter, advisors}) ->
    super(filter: filter)
    @advisors = advisors
    _.extend(@, Common.Dashboard.Filters.AssignedAdvisorFilterMixin)

  toggleOpenFilter: ->
    @openAssignedAdvisorFilterModal()
